var directive = [
  "$animateCss",
  "$parse",
  "$timeout",
  "hmTouchEvents",
  function($animateCss, $parse, $timeout, defaultEvents) {
    var debug = 0;
    return {
      restrict: "A",
      scope: false,
      compile: function(element, attrs) {
        if (window.isDesktop) return;
        var filterSwipe = attrs.hmSwipeFilter
          ? $parse(attrs.hmSwipeFilter)
          : function() {
              return false;
            };
        var swipeLeft = attrs.hmSwipeLeft
          ? $parse(attrs.hmSwipeLeft)
          : angular.noop;
        var swipeRight = attrs.hmSwipeRight
          ? $parse(attrs.hmSwipeRight)
          : angular.noop;

        function findInheritedRecognizer(element) {
          for (
            var hammer = element.inheritedData("hammer");
            hammer;
            hammer = angular
              .element(hammer.element.parentElement)
              .inheritedData("hammer")
          ) {
            var swipe = hammer.get("swipe") || hammer.get("pan");
            if (swipe) {
              return swipe;
            }
          }
        }

        return function(scope, element, attrs) {
          var mc = element.data("hammer");
          // Check for a manager, make one if needed and destroy it when
          // the scope is destroyed
          if (!mc) {
            var managerOpts = defaultEvents.extendWithDefaultManagerOpts(
              scope.$eval(attrs.hmManagerOptions)
            );
            mc = new Hammer.Manager(element[0], managerOpts);
            element.data("hammer", mc);
            scope.$on("$destroy", function() {
              mc.destroy();
            });
          } else if (mc.get("pan")) {
            return;
          }

          var recognizerOpts = defaultEvents.extendWithDefaultRecognizerOpts(
            "swipe",
            scope.$eval(attrs.hmRecognizerOptions)
          );
          mc.add(
            new Hammer.Pan(
              angular.extend(recognizerOpts, {
                event: "pan",
                direction: Hammer.DIRECTION_HORIZONTAL,
                threshold: 20
              })
            )
          );

          var parentRecognizer = findInheritedRecognizer(element.parent());

          var lastScroll = 0;
          if ("hmDetectScroll" in attrs) {
            element.on("scroll", onScroll);
          }
          function onScroll() {
            lastScroll = Date.now();
          }

          mc.on("pan", onPanHorizontal);
          element.on("$destroy", function() {
            element.off();
            mc.off("pan", onPanHorizontal);
            if (parentRecognizer) {
              parentRecognizer.set({ enable: true });
            }
          });

          function onPanHorizontal(event) {
            if (parentRecognizer) {
              parentRecognizer.set({ enable: false });
            }

            if (event.isFinal) {
              if (
                event.srcEvent.cancelable === false ||
                mc.session.firstInput.timeStamp < lastScroll
              ) {
                return;
              }

              debug &&
                console.debug("pan-release", event.deltaX, event.velocityX);

              var translate = event.deltaX;
              if (translate < -60 || translate + event.velocityX * 16 < -60) {
                if (!filterSwipe(scope, { direction: "left" })) {
                  debug && console.warn("hm.swipe-left");
                  swipeLeft(scope, { $event: event, direction: "left" });
                }
              } else if (
                translate > 60 ||
                translate + event.velocityX * 16 > 60
              ) {
                if (!filterSwipe(scope, { direction: "right" })) {
                  debug && console.warn("hm.swipe-right");
                  swipeRight(scope, { $event: event, direction: "right" });
                }
              } else {
                //
              }
            }
          }
        };
      }
    };
  }
];

window.app.directive("hmDetectScroll", [
  function() {
    return {
      scope: false,
      link: function(scope, element) {
        element.on("scroll", function(e) {
          console.warn("hmDetectScroll", e);
          scope.$emit("hm:detect-scroll");
        });
      }
    };
  }
]);

window.app.directive("hmSwipeLeft", directive);
window.app.directive("hmSwipeRight", directive);



// WEBPACK FOOTER //
// ./src/directives/hmSwipe.js